"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingsAppBuilderStaticsUrls = exports.BookingsApisBaseUrls = exports.STAFF_LIST_WIDGET_DEV_CENTER_ID = exports.DAILY_TIMETABLE_WIDGET_DEV_CENTER_ID = exports.BOOK_BUTTON_WIDGET_ID = exports.STAFF_LIST_WIDGET_ID = exports.DAILY_TIMETABLE_WIDGET_ID = exports.STAFF_LIST_APP_BUILDER_ID = exports.BOOK_BUTTON_APP_BUILDER_ID = exports.DAILY_TIMETABLE_APP_BUILDER_ID = void 0;
var bookings_uou_domain_1 = require("@wix/bookings-uou-domain");
exports.DAILY_TIMETABLE_APP_BUILDER_ID = 'drzkv';
exports.BOOK_BUTTON_APP_BUILDER_ID = 'flb7a';
exports.STAFF_LIST_APP_BUILDER_ID = 'cyng5';
exports.DAILY_TIMETABLE_WIDGET_ID = "".concat(bookings_uou_domain_1.BOOKINGS_APP_DEF_ID, "-").concat(exports.DAILY_TIMETABLE_APP_BUILDER_ID);
exports.STAFF_LIST_WIDGET_ID = "".concat(bookings_uou_domain_1.BOOKINGS_APP_DEF_ID, "-").concat(exports.STAFF_LIST_APP_BUILDER_ID);
exports.BOOK_BUTTON_WIDGET_ID = "".concat(bookings_uou_domain_1.BOOKINGS_APP_DEF_ID, "-").concat(exports.BOOK_BUTTON_APP_BUILDER_ID);
exports.DAILY_TIMETABLE_WIDGET_DEV_CENTER_ID = '89c4023a-027e-4d2a-b6b7-0b9d345b508d';
exports.STAFF_LIST_WIDGET_DEV_CENTER_ID = '3dc66bc5-5354-4ce6-a436-bd8394c09b0e';
exports.BookingsApisBaseUrls = {
    SERVICES_CATALOG: 'https://www.wixapis.com/bookings/v1/service-catalog',
};
var BookingsAppBuilderStaticsBaseUrl = 'https://bookings.wixapps.net/bookings-app-builder-statics';
exports.BookingsAppBuilderStaticsUrls = {
    BOOK_BUTTON_SETTINGS: "".concat(BookingsAppBuilderStaticsBaseUrl, "/book-button/settings"),
};
//# sourceMappingURL=platform.const.js.map